// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-list-container-parent {
  position: absolute;
  top: 75px;
  left: 200px;
  width: calc(100% - 200px);
  height: calc(100% - 75px);
  overflow: hidden;
}
.card-list-container {
  width: 100%;
  height: calc(100% - 50px);
  overflow-y: scroll;
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
  align-content: flex-start;
  -webkit-user-select: text;
          user-select: text;
}

.card-page-item-date {
  /* float: left; */
  position: absolute;
  font-size: 18px;
  line-height: 25px;
  opacity: 0.75;
  margin-left: 19px;
  height: 20px;
}
.card-page-item {
  /* display: block; */
  width: 100%;

  /* height: 400px; */
  position: relative;
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
  align-content: flex-start;
  /* font-size: 0px; */
  /* clear: both; */
  /* float: left; */
  /* zoom: 1; */

  overflow: hidden;
  clear: both;
}
.card-list-item {
  float: left;
  /* display: inline-block; */
  min-width: 330px;
  cursor: pointer;
  font-size: 15px;
  width: calc(50vw - 135px);
  height: 186px;
  opacity: 1;
  border: 15px solid transparent;
  font-size: 15px;
  line-height: 18px;
  opacity: 1;
  position: relative;
  bottom: 10px;
}
.card-list-item-card {
  height: 100%;
  border-radius: 10px;
}
.card-list-item-chapter {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 18px;
  line-height: 18px;
  font-size: 15px;
  max-width: 130px;
}
.card-list-item-citation {
  font-size: 15px;
  position: absolute;
  bottom: 35px;
  right: 15px;
  margin: 5px;
  white-space: nowrap;
  white-space: normal;
  word-break: break-all;
}
.card-list-item-text-parent {
  position: absolute;
  width: 100%;
  height: 122px;
}
.card-list-item-text-note {
  position: absolute;
  top: 110px;
  width: 100%;
  height: 104px;
  opacity: 0.6;
}
.card-list-item-text {
  width: calc(100% - 25px);
  height: 55px;
  overflow-y: scroll;
  overflow-x: hidden;
  margin: 14px 10px 0px 10px;
  position: absolute;
  cursor: text;
  line-height: 18px;
  font-size: 15px;
  padding-right: 5px;
}
.card-list-item-note {
  width: calc(100% - 25px);
  height: calc(100% - 48px);
  overflow-y: scroll;
  margin: 38px 15px 0px 15px;
  position: absolute;
  cursor: text;
  line-height: 18px;
  font-size: 15px;
  overflow-x: hidden;
}
::-webkit-scrollbar {
  width: 5px;
  height: 0.5rem;
}

::-webkit-scrollbar-track {
  border-radius: 0;
}

::-webkit-scrollbar-thumb {
  border-radius: 0;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  border-radius: 0.5rem;
  opacity: 0.2;
  border-left: solid 0.5rem transparent;
  cursor: pointer;
}
.card-list-item-title {
  float: left;
  /* width: 100px; */
}
.card-list-container-box {
  margin-top: 40px;
  height: calc(100% - 89px);
  width: 100%;
}
.icon-card-right {
  margin-left: 5px;
  line-height: 18px;
  display: inline-block;
  position: relative;
  top: 2px;
}
.card-list-item-show-more-container {
  position: absolute;
  bottom: 10px;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  right: 20px;
}
.card-list-item-show-more {
  font-size: 15px;
  line-height: 18px;
  opacity: 1;
  text-align: center;
  cursor: pointer;
  padding: 0px 10px;
}
.card-list-show-more-icon {
  /* display: block; */
  font-size: 13px;
  line-height: 18px;
  opacity: 1;
  text-align: center;
  position: absolute;
  bottom: 5px;
  margin-left: calc(50% - 6px);
}

/* 分页加载相关样式 */
.card-list-loading {
  width: 100%;
  text-align: center;
  padding: 20px 0;
  margin: 10px 0;
}

.loading-spinner {
  display: inline-block;
  padding: 12px 24px;
  font-size: 14px;
  color: #666;
  background-color: #f5f5f5;
  border-radius: 6px;
  opacity: 0.8;
}

.card-list-end {
  width: 100%;
  text-align: center;
  padding: 20px 0;
  margin: 10px 0;
}

.end-message {
  display: inline-block;
  padding: 12px 24px;
  font-size: 14px;
  color: #999;
  border-top: 1px solid #e0e0e0;
  opacity: 0.6;
}
`, "",{"version":3,"sources":["webpack://./src/containers/lists/cardList/cardList.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,WAAW;;EAEX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;;EAEb,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,UAAU;EACV,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,4BAAoB;EAApB,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;EACZ,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,4BAA4B;AAC9B;;AAEA,aAAa;AACb;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,YAAY;AACd","sourcesContent":[".card-list-container-parent {\n  position: absolute;\n  top: 75px;\n  left: 200px;\n  width: calc(100% - 200px);\n  height: calc(100% - 75px);\n  overflow: hidden;\n}\n.card-list-container {\n  width: 100%;\n  height: calc(100% - 50px);\n  overflow-y: scroll;\n  display: flex;\n  flex-wrap: wrap;\n  overflow-y: scroll;\n  align-content: flex-start;\n  user-select: text;\n}\n\n.card-page-item-date {\n  /* float: left; */\n  position: absolute;\n  font-size: 18px;\n  line-height: 25px;\n  opacity: 0.75;\n  margin-left: 19px;\n  height: 20px;\n}\n.card-page-item {\n  /* display: block; */\n  width: 100%;\n\n  /* height: 400px; */\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  overflow-y: scroll;\n  align-content: flex-start;\n  /* font-size: 0px; */\n  /* clear: both; */\n  /* float: left; */\n  /* zoom: 1; */\n\n  overflow: hidden;\n  clear: both;\n}\n.card-list-item {\n  float: left;\n  /* display: inline-block; */\n  min-width: 330px;\n  cursor: pointer;\n  font-size: 15px;\n  width: calc(50vw - 135px);\n  height: 186px;\n  opacity: 1;\n  border: 15px solid transparent;\n  font-size: 15px;\n  line-height: 18px;\n  opacity: 1;\n  position: relative;\n  bottom: 10px;\n}\n.card-list-item-card {\n  height: 100%;\n  border-radius: 10px;\n}\n.card-list-item-chapter {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  height: 18px;\n  line-height: 18px;\n  font-size: 15px;\n  max-width: 130px;\n}\n.card-list-item-citation {\n  font-size: 15px;\n  position: absolute;\n  bottom: 35px;\n  right: 15px;\n  margin: 5px;\n  white-space: nowrap;\n  white-space: normal;\n  word-break: break-all;\n}\n.card-list-item-text-parent {\n  position: absolute;\n  width: 100%;\n  height: 122px;\n}\n.card-list-item-text-note {\n  position: absolute;\n  top: 110px;\n  width: 100%;\n  height: 104px;\n  opacity: 0.6;\n}\n.card-list-item-text {\n  width: calc(100% - 25px);\n  height: 55px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  margin: 14px 10px 0px 10px;\n  position: absolute;\n  cursor: text;\n  line-height: 18px;\n  font-size: 15px;\n  padding-right: 5px;\n}\n.card-list-item-note {\n  width: calc(100% - 25px);\n  height: calc(100% - 48px);\n  overflow-y: scroll;\n  margin: 38px 15px 0px 15px;\n  position: absolute;\n  cursor: text;\n  line-height: 18px;\n  font-size: 15px;\n  overflow-x: hidden;\n}\n::-webkit-scrollbar {\n  width: 5px;\n  height: 0.5rem;\n}\n\n::-webkit-scrollbar-track {\n  border-radius: 0;\n}\n\n::-webkit-scrollbar-thumb {\n  border-radius: 0;\n  transition: all 0.2s;\n  border-radius: 0.5rem;\n  opacity: 0.2;\n  border-left: solid 0.5rem transparent;\n  cursor: pointer;\n}\n.card-list-item-title {\n  float: left;\n  /* width: 100px; */\n}\n.card-list-container-box {\n  margin-top: 40px;\n  height: calc(100% - 89px);\n  width: 100%;\n}\n.icon-card-right {\n  margin-left: 5px;\n  line-height: 18px;\n  display: inline-block;\n  position: relative;\n  top: 2px;\n}\n.card-list-item-show-more-container {\n  position: absolute;\n  bottom: 10px;\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  right: 20px;\n}\n.card-list-item-show-more {\n  font-size: 15px;\n  line-height: 18px;\n  opacity: 1;\n  text-align: center;\n  cursor: pointer;\n  padding: 0px 10px;\n}\n.card-list-show-more-icon {\n  /* display: block; */\n  font-size: 13px;\n  line-height: 18px;\n  opacity: 1;\n  text-align: center;\n  position: absolute;\n  bottom: 5px;\n  margin-left: calc(50% - 6px);\n}\n\n/* 分页加载相关样式 */\n.card-list-loading {\n  width: 100%;\n  text-align: center;\n  padding: 20px 0;\n  margin: 10px 0;\n}\n\n.loading-spinner {\n  display: inline-block;\n  padding: 12px 24px;\n  font-size: 14px;\n  color: #666;\n  background-color: #f5f5f5;\n  border-radius: 6px;\n  opacity: 0.8;\n}\n\n.card-list-end {\n  width: 100%;\n  text-align: center;\n  padding: 20px 0;\n  margin: 10px 0;\n}\n\n.end-message {\n  display: inline-block;\n  padding: 12px 24px;\n  font-size: 14px;\n  color: #999;\n  border-top: 1px solid #e0e0e0;\n  opacity: 0.6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
